import React from 'react'
import Box from '../components/Box'

export default function Section2() {
    return (
        <div className="section">
            <h2>Section II: Rosters and Students</h2>
            <Box sectionData={'start'} title={'Create Class Roster'} body={`
        1. Tap the “Manage” button and select “Roster” from the menu. 
        2. Tap the “+” button to add a new student to the class roster. 
        3. Enter the student information (only the surname field is required).  
        4. Tap “Save” to save the entered information and return to the roster manager screen. Tap “Save 
        & Add” to save the entered information and immediately add another student.`} />



            <Box title={'Quick Add Student'} body={`1. Select a class as described above. 
        2. Tap the “Action” button on the bottom toolbar. 
        3. Select “Create Student” 
        4. Follow steps (3) – (4) in the “Create Class Roster” section above.`} />


            <Box title={'Edit Student'} body={`1. Tap the “Manage” button and select “Roster” from the menu. 
        2. Tap the student to be edited. 
        3. Enter or change the student information.  
        4. Tap “Save” to save the entered information and return to the roster manager screen. Tap “Save 
        & Add” to save the entered information and immediately add a student.`} />



            <Box title={'Add or Edit Student Photo'} body={`Notes: 
        • The app will resize the photos to an appropriate size; choose any resolution image available to 
        you. 
        • Photos do not need to remain in the photo library after being assigned to a student; a copy of 
        the photo is made and retained in the app database. 
        1. Tap the “Manage” button and select “Roster” from the menu. 
        2. Tap the student that is to be edited. 
        3. Tap the camera button. 
        4. Tap  the  “Clear”  button  to  remove  an  existing  photo  or  select  one  of  the  following  to  assign  a 
        photo: 
        a. “From Library” to assign a photo unedited from the photo library. 
        b. “From  Library  (Cropped)”  to  assign  a  photo  from  the  photo  library  after  zooming  and 
        cropping the photo. 
        c. “From Camera” to take a new photo and assign it without editing. 
        d. “From  Camera  (Cropped)”  to  take  a  new  photo  and  assign  it  after  zooming  and 
        cropping. 
        5. Tap “Use” to assign the photo.`} />



            <Box title={'Copy Student'} body={`Notes:  
        • Copying a student will create a new student with the same details (name, photo, email, etc...) 
        as the source. No scores, behavior records, or attendance entries are copied. 
        1. Select the destination class as described previously.  
        2. Tap the “Manage” button and select “Roster” from the menu. 
        3. Tap the “Copy” button on the top toolbar.  
        4. Select the source class from the list.  
        5. Select the students to be copied and tap “Done”`} />


            <Box title={'Import Roster'} body={`Note: 
        • See Section: Importing Class Rosters for details on creating and importing roster files. 
        1. Select a class as described above. 
        2. Tap the “Manage” button and select “Roster” from the menu. 
        3. Tap the “Import” button on the top toolbar. 
        4. Select the file to import.  
        a. Files in the app documents directory are displayed in the list and may be selected.  
        b. On iOS 8.0 and greater select “Other...” to display the system document picker to select 
        files directly from any app that has a document picker available (Dropbox, Box, Google 
        Drive, etc...).`} />



            <Box title={'Drop Student'} body={`Marking  a  student  as  dropped  will  exclude  them  from  assignments  and  attendance  reports  after  the 
        specified drop date.  
        1. Tap the “Manage” button and select “Roster” from the menu. 
        2. Tap the student to be dropped. 
        3. Tap the “Status” button. 
        4. Select “Set Drop Date” or “Clear Drop Date”. 
        5. If  setting  the  date  a  date  picker  will  be  displayed.    Select  the  date  that  the  student  dropped. 
        Note that the date picker will not allow a selection outside the term start and end dates. 
        6. Tap “Confirm” `} />


            <Box sectionData={'end'} title={'Delete Student'} body={`Note:  
        • This  cannot  be  undone. All  student  data,  scores,  attendance  records,  behavior  records,  and 
        notes will be permanently deleted.  
        1. Tap the “Manage” button and select “Roster” from the menu. 
        2. Tap the “Edit” button. 
        3. Tap the “-“ button on the student to be deleted. The typical swipe to delete gesture also works.  
        4. Confirm by tapping the “Delete” button. 
        5. Confirm again by selecting ‘Delete Student’`} />
        </div>
    )
}